export default __webpack_public_path__ + "images/SL.c4960e3.png";